import { Component } from '@angular/core';
import { DigitalerHoerverlustResults } from '@workflow/components/questionnaire/questionnaire-item/special-question/digitaler-hoerverlust/digitaler-hoerverlust.component';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-digitaler-hoerverlust-epilog',
	templateUrl: './digitaler-hoerverlust-epilog.component.html',
	styleUrls: ['./digitaler-hoerverlust-epilog.component.scss']
})
export class DigitalerHoerverlustEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<DigitalerHoerverlustResults>) {}
}

